import { Drawer, DrawerProps, Typography } from '@mui/material';
import React, { FC, useRef } from 'react';
import { Back, Close } from '@menuzen/icon/build/outline';
import useSwipe from '../../hooks/useSwipe';

export interface DialogProps extends DrawerProps {
    title?: string;
    subtitle?: string;
    onBack?: () => void;
    showClose?: boolean;
    onClose: () => void;
}

const Dialog: FC<DialogProps> = ({ open, title, subtitle, showClose, onBack, onClose, children, ...props }) => {
    const paperRef = useRef();
    const { transform, onTouchEnd, onTouchMove, onTouchStart } = useSwipe({
        open,
        onClose,
        paperRef,
    });

    return (
        <Drawer
            PaperProps={{
                style: {
                    maxWidth: 620,
                    margin: '0px auto',
                    transform,
                    paddingTop: 0,
                },
                ref: paperRef,
            }}
            onClose={() => onClose()}
            anchor="bottom"
            open={!!open}
            {...props}
        >
            <div className="pt-16" onTouchEnd={onTouchEnd} onTouchMove={onTouchMove} onTouchStart={onTouchStart}>
                <div className={`flex justify-center text-primary-40 text-6`}>
                    <svg width="50" height="5" viewBox="0 0 50 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="50" height="5" rx="2.5" fill="#E0E1E3" />
                    </svg>
                </div>
                {title && (
                    <div className={`flex w-full px-28 mt-12`}>
                        <div className={`w-40 flex-shrink-0`}>
                            {onBack && (
                                <div className="text-24 text-primary-70" onClick={onBack}>
                                    <Back />
                                </div>
                            )}
                        </div>
                        <div className={`text-18 font-semibold flex-auto text-center`}>{title}</div>
                        <div className={`w-40 flex-shrink-0 flex justify-end`}>
                            {showClose && (
                                <div className="text-24 text-primary-70 cursor-pointer" onClick={onClose}>
                                    <Close />
                                </div>
                            )}
                        </div>
                    </div>
                )}
                {subtitle && (
                    <Typography
                        variant="inherit"
                        component="p"
                        className={'text-center flex-auto pb-20 text-primary-70'}
                    >
                        {subtitle}
                    </Typography>
                )}
            </div>
            <div className={`flex flex-col flex-auto overflow-y-auto`}>{children}</div>
        </Drawer>
    );
};

export default Dialog;
